import Backbone from 'backbone'
import _ from 'lodash'
import deviceType from 'scoreboard/components/device-type'
import mobile from 'scoreboard/components/mobile'
import layoutManager from 'scoreboard/components/layout-manager'

var FowardBackwardSizer = Backbone.View.extend({

	/**
	 * Prevents resizing a select instantly when changing its
	 * value via forward/backward buttons. This allows the user to
	 * click the forward/backward buttons without them jumping arround. Issue #17023.
	 *
	 * @constructs
	 *
	 * @param {Object} options.select // The select that should be resized
	 * @param {Object} options.forward // Forward button element
	 * @param {Object} options.backward // Backward button element
	 * @param {Object} options.controls // The wrapper around the buttons
	 *
	 * @param {Boolean} [options.mobileResizeOnly=true] // If the element should only be resized in mobile layouts
	 *
	 */

	initialize(options) {
		this.options = options || {}
	},

	render() {
		this.options.forward.on('click', () => this.forward())
		this.options.backward.on('click', () => this.backward())
		let slideControls = this.options.controls.closest('.slide-controls')
		// Only capture size when the user is getting ready to click.
		this.options.controls.on('mousedown', (e) => {
			if (this.mouseDownLeaveSizing() &&
				!slideControls.hasClass('slide-controls-small')) {
				this.setSelectSize()
			}
		})

		this.options.controls.on('mouseleave', () => {
			if (this.mouseDownLeaveSizing() &&
				!slideControls.hasClass('slide-controls-small')) {
				this.releaseSelectSize()
			}
		})

		return this
	},

	// Only allow the mousedown/mouseleave sizing to work on non-mobile devices.
	// But we also want to allow it any time the period-display tab drops down and is in the middle
	// which occours for narrow desktop windows or if the nav-pane is wide making the display-pane narrow.
	mouseDownLeaveSizing() {
		let displaySize = layoutManager.getDisplaySize()
		let mobileOnlyAndMobileWidth = this.options.mobileResizeOnly && mobile.isMobileWidth()
		let mobileOnlyAndSmallerDisplays = this.options.mobileResizeOnly && (displaySize == 'display-small' || displaySize == 'display-medium')
		return !this.options.mobileResizeOnly || mobileOnlyAndMobileWidth || mobileOnlyAndSmallerDisplays
	},

	setSelectSize() {
		let select = this.options.select
		let width = select.width()
		// CSS can't transition a width to an "auto" width. However, we can
		// transition to `min-width: 0;` and `max-width: 100%;` if we have a starting point.
		// Since we don't know if its going to get narrower or wider, we'll have to set both.
		select.css({
			'max-width': width,
			'min-width': width,
			'width': width
		})
	},

	releaseSelectSize() {
		let select = this.options.select
		select.css({
			'max-width': '',
			'min-width': '',
			'width': ''
		})
		this.clearMobileInterval()
	},

	clearMobileInterval() {
		if (!_.isNil(this.mobileSize)) {
			clearInterval(this.mobileSize)
			delete this.mobileSize
		}
	},

	// If mobile, after clicking forward/backward, pause 1 second before
	// resizing the select.
	mobileSizing() {
		if (deviceType.isMobile()) {
			this.clearMobileInterval()
			this.setSelectSize()
			// Using setInterval instead of setTimeout because we need to be
			// able to clear/restart the timer if another button is clicked.
			this.mobileSize = setInterval(() => {
				 this.releaseSelectSize()
			 }, 1000)
		}
	},

	forward() {
		this.mobileSizing()
		this.trigger('forward')
	},

	backward() {
		this.mobileSizing()
		this.trigger('backward')
	}

})

export default FowardBackwardSizer


FowardBackwardSizer.__filename__ = 'components/forward-backward-sizer.js'
